function parseTags(raw) {
  if (!raw) return [];
  const s = raw.trim();
  let tags = [];
  // JSON array: ["a", "b"] or ['a', 'b']
  if (s.startsWith('[')) {
    try {
      const parsed = JSON.parse(s.replace(/'/g, '"'));
      tags = Array.isArray(parsed) ? parsed.map((t) => t.trim()).filter(Boolean) : [];
    } catch {
      tags = s.split(',').map((t) => t.trim()).filter(Boolean);
    }
  } else {
    // Comma-separated: security, ctf, web
    tags = s.split(',').map((t) => t.trim()).filter(Boolean);
  }
  // Normalize: lowercase, deduplicate
  return [...new Set(tags.map((t) => t.toLowerCase().replace(/\s+/g, '-')))];
}

function parseFrontmatter(raw) {
  // Normalize line endings
  const normalized = raw.replace(/\r\n/g, '\n');
  const match = normalized.match(/^---[ \t]*\n([\s\S]*?)\n---[ \t]*\n?([\s\S]*)$/);
  if (!match) return { data: {}, content: normalized };

  const data = {};
  const lines = match[1].split('\n');
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    const colon = line.indexOf(':');
    if (colon === -1) { i++; continue; }

    const key = line.slice(0, colon).trim();
    let value = line.slice(colon + 1).trim();

    // Handle multi-line quoted strings: if opening quote has no matching closing quote,
    // keep appending subsequent lines until the closing quote is found.
    if (value.length > 0 && (value[0] === '"' || value[0] === "'")) {
      const q = value[0];
      // Check if closing quote exists after the opening one
      while (value.indexOf(q, 1) === -1 && i + 1 < lines.length) {
        i++;
        value += ' ' + lines[i].trim();
      }
    }

    // Strip surrounding matching quotes
    if (
      value.length >= 2 &&
      ((value[0] === '"' && value[value.length - 1] === '"') ||
        (value[0] === "'" && value[value.length - 1] === "'"))
    ) {
      value = value.slice(1, -1);
    }

    if (key) data[key] = value;
    i++;
  }

  return { data, content: match[2] };
}

async function fetchFileList() {
  const res = await fetch('/.netlify/functions/github-posts');
  if (!res.ok) throw new Error('Failed to fetch posts list from GitHub');
  return res.json();
}

async function parsePost(file) {
  const raw = await fetch(file.download_url).then((r) => r.text());
  const { data, content } = parseFrontmatter(raw);
  const slug = file.name.replace(/\.md$/, '');
  return {
    slug,
    sys: {
      id: file.sha,
      createdAt: data.date ? new Date(data.date).toISOString() : new Date().toISOString(),
    },
    fields: {
      title: data.title || slug,
      description: data.description || '',
      headerImage: data.headerImage || null,
      mainText: content,
      tags: parseTags(data.tags),
    },
  };
}

export async function fetchPosts() {
  const files = await fetchFileList();
  // Use allSettled so a single bad file doesn't drop all posts
  const results = await Promise.allSettled(files.map(parsePost));
  const posts = results
    .filter((r) => r.status === 'fulfilled')
    .map((r) => r.value);
  return posts.sort((a, b) => new Date(b.sys.createdAt) - new Date(a.sys.createdAt));
}

export async function fetchPostBySlug(slug) {
  const posts = await fetchPosts();
  return posts.find((p) => p.slug === slug) || null;
}
